import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import config from "../Helpers/config.json";
import {useSnackbar} from "./snackbar-context";
import { mpekeLogo } from "./mpekeLogo";
import {history} from "../Helpers/history";
import companyInfo from '../Helpers/companyAddress.json'


const CompanyContext = React.createContext()
CompanyContext.displayName = 'CompanyContext'


function CompanyProvider(props) {
    const {handleSuccess, handleError} = useSnackbar()
    const [state, setState] = useState(()=>({companyName: companyInfo.company_name, companyEmail: companyInfo.email,
        mobile: companyInfo.mobile, address: companyInfo.address, website: companyInfo.website, logo: companyInfo.img_url}));
    const [selectedFile, setSelectedFile] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [filename, setFilename] = useState(null);
    const [companyDetails,setCompanyDetails]= useState(null)

    const inputRef = useRef()


    const isResolved = isSubmitted === 'resolved'

    const url = history.location.pathname


    useEffect(() => {
        axios.get(`${config.epharmUrl}/User/view_company_info`)
            .then((response) => {
                const data= response.data? response.data:{}
                setCompanyDetails(data);
            }).catch(err=>{
        });
    }, [isResolved, url]);

    useEffect(() => {
        if(!companyDetails){
            setState({...state,companyName: companyInfo.company_name, companyEmail: companyInfo.email,
            mobile: companyInfo.mobile, address: companyInfo.address, website: companyInfo.website, logo: companyInfo.img_url})
            return
        }
        setState({...state,companyName: companyDetails.company_name,
            companyEmail:companyDetails.email, mobile:companyDetails.mobile,
            address:companyDetails.address, website:companyDetails.website, logo:companyDetails.img_url})
        setFilename(companyDetails.img_url)
        setSelectedFile(companyDetails.img_url)
    },[companyDetails])


    const convertToBase64 = (selectedFile) => {
        const reader = new FileReader()

        reader.readAsDataURL(selectedFile)

        reader.onload = () => {
            setFilename(reader.result)
            setSelectedFile(reader.result)
        }
    }


    const handleImageSelection = (e) => {
        convertToBase64(e.target.files[0])
    };



    const handleChange = event => {
        const {name, value} = event.target;
        setState({...state, [name]: value})
    };
    

    const handleSubmit = event => {
        event.preventDefault();
        const {companyName, companyEmail, mobile, address, website} = state;
        setSubmitted(true)
        const logo  = mpekeLogo()
        const file = selectedFile ? selectedFile : logo
        if (companyName  && mobile && address) {
            setIsSubmitted('pending')
            const data = {
                company_name: companyName,
                email: companyEmail,
                mobile:mobile,
                address:address,
                website:website,
                logo: file
            }
            axios.post(`${config.epharmUrl}/User/add_company_info`, data)
                .then(() => {
                    setIsSubmitted('resolved')
                    handleSuccess(`Company saved successfully!`);
                    // history.push("/editcompanydetails")
                }).catch(error => {
                setIsSubmitted('rejected')
                handleError('Operation Unsuccessful')
            })
        }

    };

    const value = {state, selectedFile,  submitted,companyDetails,inputRef,
        isSubmitted, handleChange, handleSubmit, handleImageSelection,filename}
    return <CompanyContext.Provider value={value}  {...props}/>
}

function useCompany() {
    const context = React.useContext(CompanyContext)
    if (context === undefined) {
        throw new Error(`useCompany must be used within a CompanyProvider`)
    }
    return context
}

export {CompanyProvider, useCompany}



// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import config from "../Helpers/config.json";
// import { useSnackbar } from "./snackbar-context";
// import { mpekeLogo } from "./mpekeLogo";
// import { history } from "../Helpers/history";

// const CompanyContext = React.createContext();
// CompanyContext.displayName = "CompanyContext";

// function CompanyProvider(props) {
//   const { handleSuccess, handleError } = useSnackbar();

//   const [companyState, setCompanyState] = useState({
//     companyName: "",
//     companyEmail: "",
//     mobile: "",
//     address: "",
//     website: "",
//     logo: "",
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [filename, setFilename] = useState(null);
//   const [isSubmitted, setIsSubmitted] = useState("idle");
//   const [companyDetails, setCompanyDetails] = useState(null);
//   const inputRef = useRef();

//   const url = history.location.pathname;
//   const isResolved = isSubmitted === "resolved";

//   // Fetch company info
//   useEffect(() => {
//     const fetchCompanyInfo = async () => {
//       try {
//         const response = await axios.get(`${config.epharmUrl}/User/view_company_info`);
//         setCompanyDetails(response.data || null);
//       } catch (err) {
//         handleError("Failed to load company info");
//       }
//     };
//     fetchCompanyInfo();
//   }, [isResolved, url, handleError]);

//   // Sync companyDetails into state
//   useEffect(() => {
//     if (!companyDetails) return;

//     setCompanyState({
//       companyName: companyDetails.company_name || "",
//       companyEmail: companyDetails.email || "",
//       mobile: companyDetails.mobile || "",
//       address: companyDetails.address || "",
//       website: companyDetails.website || "",
//       logo: companyDetails.img_url || "",
//     });

//     setFilename(companyDetails.img_url || null);
//     setSelectedFile(companyDetails.img_url || null);
//   }, [companyDetails]);

//   // Convert selected file to Base64
//   const convertToBase64 = (file) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => {
//       setFilename(reader.result);
//       setSelectedFile(reader.result);
//     };
//     reader.onerror = () => {
//       handleError("Failed to read file");
//     };
//   };

//   const handleImageSelection = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       convertToBase64(e.target.files[0]);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCompanyState((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const { companyName, companyEmail, mobile, address, website } = companyState;
//     const file = selectedFile || mpekeLogo();

//     if (!companyName || !mobile || !address) {
//       handleError("Company Name, Mobile, and Address are required");
//       return;
//     }

//     setIsSubmitted("pending");

//     const data = {
//       company_name: companyName,
//       email: companyEmail,
//       mobile,
//       address,
//       website,
//       logo: file,
//     };

//     try {
//       await axios.post(`${config.epharmUrl}/User/add_company_info`, data);
//       setIsSubmitted("resolved");
//       handleSuccess("Company saved successfully!");
//     } catch (err) {
//       setIsSubmitted("rejected");
//       handleError("Operation unsuccessful");
//     }
//   };

//   const value = {
//     state: companyState,
//     selectedFile,
//     filename,
//     companyDetails,
//     inputRef,
//     isSubmitted,
//     handleChange,
//     handleSubmit,
//     handleImageSelection,
//   };

//   return <CompanyContext.Provider value={value} {...props} />;
// }

// function useCompany() {
//   const context = React.useContext(CompanyContext);
//   if (!context) {
//     throw new Error("useCompany must be used within a CompanyProvider");
//   }
//   return context;
// }

// export { CompanyProvider, useCompany };
